import React, { memo } from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./home/Home";
import Products from "./products/Products";
import Product from "./products/product";
import Blog from "./blog/Blog";
import Fav from "./home/fav";
import useLocationBlocker from "../../shared/functions/useLocationBlocker";
import CheckoutPage from "./checkout/CheckoutPage";
import ConfirmationPage from "./checkout/ConfirmationPage";
import AboutUs from "./others/AboutUs";
import Terms from "./others/terms";
import BuyingForm from "./others/BuyingForm";
import BlogDetail from "./blog/BlogDetail";
import Layout from "../../shared/components/Layout";

function Routing(props) {
  const { selectBlog, selectHome, data, types, selectProduct } = props;
  useLocationBlocker();

  return (
    <Layout>
      <Routes>
        <Route path="/blog" element={<Blog selectBlog={selectBlog} />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/confirmation" element={<ConfirmationPage />} />
        <Route path="/fav" element={<Fav data={data} />} />
        <Route path="/ostoehdot" element={<Terms />} />
        <Route path="/products/:id" element={<Product />} />
        <Route path="/tuotteet/:category/:slug" element={<Product />} />
        <Route
          path="/products"
          element={<Products selectProduct={selectProduct} data={data} types={types} />}
        />
        <Route path="/meista" element={<AboutUs />} />
        <Route path="/blogi" element={<Blog />} />
        <Route path="/lahjoita-ja-myyda" element={<BuyingForm />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        <Route
          path="/"
          element={<Home selectHome={selectHome} data={data} types={types} />}
        />
      </Routes>
    </Layout>
  );
}

export default memo(Routing);
